import { trans } from "../lib/utils";

const initialState = {
  leftPanelActiveTab: "layers",
  guideTour: [
    {
      target: "#left-menu",
      content: trans("Here you will find PP tools"),
      placement: "auto",
    },
    {
      target: ".map-controls",
      content: trans("Here you will find various Map tools"),
      placement: "auto",
    },
    {
      target: ".results-panel",
      content: trans("Here you will find search results and many more"),
      placement: "auto",
    },
  ],
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case "app/leftPanelActiveTab":
      {
        let newState = { ...state };

        newState.leftPanelActiveTab = action.payload;

        return { ...newState };
      }
      break;

    default:
      return state;
  }
}
